import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { API } from "@/lib/api";

export default function WelcomeOverlay({ userName, onComplete }) {
  const [step, setStep] = useState(0);
  const firstName = userName?.split(' ')[0] || '';

  const handleDismiss = async () => {
    try { await API.post("/auth/welcome-seen"); } catch {}
    onComplete();
  };

  useEffect(() => {
    const t1 = setTimeout(() => setStep(1), 600);
    const t2 = setTimeout(() => setStep(2), 2000);
    const t3 = setTimeout(() => setStep(3), 3400);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-white"
      data-testid="welcome-overlay"
    >
      <div className="max-w-lg mx-auto px-8 text-center">
        <AnimatePresence>
          {step >= 1 && (
            <motion.p
              key="greeting"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="text-sm uppercase tracking-[0.25em] text-[#A0655A] font-medium mb-6"
            >
              {firstName ? `Välkommen, ${firstName}` : 'Välkommen'}
            </motion.p>
          )}
        </AnimatePresence>

        <AnimatePresence>
          {step >= 2 && (
            <motion.div
              key="message"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <h1 className="heading-font text-3xl sm:text-4xl font-medium text-[#111111] mb-6 leading-snug">
                Det här är början<br />på din inre resa
              </h1>
              <p className="text-[#111111]/50 text-base leading-relaxed max-w-sm mx-auto mb-2">
                Du kommer att guidas genom tre faser — klarhet, frigörelse och förankring.
              </p>
              <p className="text-[#111111]/50 text-base leading-relaxed max-w-sm mx-auto">
                Det finns inget rätt eller fel här. Bara du, i din egen takt.
              </p>
            </motion.div>
          )}
        </AnimatePresence>

        <AnimatePresence>
          {step >= 3 && (
            <motion.div
              key="cta"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="mt-10"
            >
              <Button
                onClick={handleDismiss}
                className="bg-[#A0655A] hover:bg-[#8B5549] text-white rounded-full px-10 py-6 text-base"
                data-testid="welcome-start-btn"
              >
                Jag är redo
              </Button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
